<template>
  <div class="projects-page">
    <!-- Page Header -->
    <div class="page-header">
      <div class="section-container">
        <h1 class="page-header__title">Proyek Kami</h1>
        <div class="page-header__breadcrumb">
          <router-link to="/miraverse">Miraverse.ID</router-link>
          <span>/</span>
          <span>Proyek</span>
        </div>
      </div>
    </div>

    <!-- Projects Grid -->
    <section class="section">
      <div class="section-container">
        <div class="section-title animate-on-scroll">
          <span class="badge-label">
            <span class="badge-label__dot"></span>
            Portfolio
          </span>
          <h2>Proyek <span class="text-gradient">Terbaru</span> Kami</h2>
          <p class="section-subtitle">Berikut beberapa proyek yang telah kami kerjakan untuk klien kami.</p>
        </div>

        <div class="portfolio-grid">
          <div v-for="(project, index) in projects" :key="project.id" class="portfolio-card animate-on-scroll"
            :class="'delay-' + ((index % 3) + 1)">
            <div class="portfolio-card__image">
              <img :src="project.image" :alt="project.name" />
              <div class="portfolio-card__overlay">
                <div class="portfolio-card__category">{{ project.category }}</div>
              </div>
            </div>
            <div class="portfolio-card__content">
              <h3>{{ project.name }}</h3>
              <p>{{ project.description }}</p>
              <div class="portfolio-card__tags">
                <span v-for="tag in project.tags" :key="tag">{{ tag }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ProjectsPage',
  data() {
    return {
      projects: [
        {
          id: 1,
          name: 'Sistem Informasi Sekolah',
          description: 'Aplikasi mobile manajemen sekolah terintegrasi dengan modul keuangan, absensi, penilaian, dan agenda siswa. Mendukung pembayaran digital dan pemantauan tagihan secara real-time.',
          category: 'Mobile App',
          image: require('@/assets/images/project-school-app.png'),
          tags: ['Flutter', 'Laravel', 'MySQL']
        },
        {
          id: 2,
          name: 'Sistem Informasi Dana Pensiun',
          description: 'Platform manajemen investasi dana pensiun dengan fitur pengelolaan investasi (Deposito, Obligasi, Saham, dll), keuangan, dan pelaporan transaksi. Dilengkapi dashboard analitik dan audit trail.',
          category: 'Web Application',
          image: require('@/assets/images/project-pension-fund.png'),
          tags: ['Vue.js', '.NET', 'MS SQL Server']
        },
        {
          id: 3,
          name: 'Core Banking System',
          description: 'Sistem perbankan inti dengan dashboard monitoring dana masuk, analitik sumber dana, pengelolaan kas, dan pelaporan keuangan komprehensif.',
          category: 'Web Application',
          image: require('@/assets/images/project-core-banking.png'),
          tags: ['Vue.js', 'Nest.js', 'MySQL']
        }
      ]
    }
  },
  mounted() {
    this.initScrollAnimations()
  },
  methods: {
    initScrollAnimations() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) { entry.target.classList.add('animated') }
          })
        },
        { threshold: 0.1 }
      )
      this.$nextTick(() => {
        document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el))
      })
    }
  }
}
</script>

<style scoped lang="scss">
.text-gradient {
  background: linear-gradient(135deg, #6C2973, #C73468);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.portfolio-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
}

.portfolio-card {
  border-radius: 20px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 24px rgba(108, 41, 115, 0.08);
  transition: all 0.35s ease;
  border: 1px solid rgba(108, 41, 115, 0.06);

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 16px 50px rgba(108, 41, 115, 0.15);

    .portfolio-card__image img {
      transform: scale(1.07);
    }
  }
}

.portfolio-card__image {
  position: relative;
  height: 260px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
  }
}

.portfolio-card__overlay {
  position: absolute;
  top: 16px;
  left: 16px;
}

.portfolio-card__category {
  background: linear-gradient(135deg, #6C2973, #C73468);
  color: #fff;
  padding: 5px 16px;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.portfolio-card__content {
  padding: 28px;

  h3 {
    font-size: 1.2rem;
    margin-bottom: 10px;
  }

  p {
    font-size: 0.92rem;
    color: $text-body;
    line-height: 1.7;
    margin-bottom: 16px;
  }
}

.portfolio-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;

  span {
    background: rgba(108, 41, 115, 0.06);
    color: #6C2973;
    padding: 4px 12px;
    border-radius: 50px;
    font-size: 0.75rem;
    font-weight: 600;
  }
}

@media (max-width: 991px) {
  .portfolio-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 576px) {
  .portfolio-grid {
    grid-template-columns: 1fr;
  }
}
</style>
